import React, { Fragment, useEffect, useState } from 'react';
import { ReactComponent as DealDetailsIcon } from 'assets/icons/post-details.svg';
import { ReactComponent as DealTimelineIcon } from 'assets/icons/post-timeline.svg';
import { ReactComponent as DealSettingsIcon } from 'assets/icons/deal-settings.svg';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import useEditDealContext from 'contexts/edit-deal.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { handleApiError } from 'utils/functions';
import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg';
import { getPayload } from './util';

const EditDealContent = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { dealId } = useParams();
  const { pathname } = useLocation();

  const DealDetailsNav = [
    {
      title: 'Deal details',
      link: `/deals/${dealId}/edit/${ROUTE_KEYS.EDIT_DEAL_DETAILS}`,
      Icon: DealDetailsIcon
    },
    {
      title: 'Deal settings',
      link: `/deals/${dealId}/edit/${ROUTE_KEYS.EDIT_DEAL_SETTINGS}`,
      Icon: DealSettingsIcon
    },
    {
      title: 'Deal timeline',
      link: `/deals/${dealId}/edit/${ROUTE_KEYS.EDIT_DEAL_TIMELINE}`,
      Icon: DealTimelineIcon
    }
  ];
  const { setRightSection } = useDashboardContext();
  const { disabled, editDealForm } = useEditDealContext();

  useEffect(() => {
    setRightSection(<RightSidebar title='Deal Information' list={DealDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const isDetailsPage = pathname.endsWith(`edit/${ROUTE_KEYS.EDIT_DEAL_DETAILS}`);
  const isSettingsPage = pathname.endsWith(`edit/${ROUTE_KEYS.EDIT_DEAL_SETTINGS}`);
  const isTimelinePage = pathname.endsWith(`edit/${ROUTE_KEYS.EDIT_DEAL_TIMELINE}`);

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const res = await apiService.put(`marketing/deal/${dealId}`, {
        data: getPayload(editDealForm, isDetailsPage, isSettingsPage, isTimelinePage),
        isInternal: true
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(ROUTE_KEYS.DEALS_AND_DISCOUNTS);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const backLink = isDetailsPage
    ? ROUTE_KEYS.DEALS_AND_DISCOUNTS
    : isSettingsPage
    ? `/deals/${dealId}/edit/${ROUTE_KEYS.EDIT_DEAL_DETAILS}`
    : isTimelinePage
    ? `/deals/${dealId}/edit/${ROUTE_KEYS.EDIT_DEAL_SETTINGS}`
    : '#';

  return (
    <Fragment>
      <Outlet />
      <div className='mx-10 pb-8 max-w-[700px] flex items-center justify-between mt-12'>
        <Link to={backLink} className='p-[10px] rounded-full bg-gray-36 cursor-pointer '>
          <LeftArrow />
        </Link>

        <div className='flex items-center gap-8'>
          <Link to={ROUTE_KEYS.DEALS_AND_DISCOUNTS} className='text-red-5 text-sm'>
            Cancel
          </Link>
          <Button
            onClick={handleConfirm}
            small
            variant='block'
            color='primary'
            className='text-sm'
            disabled={disabled}
            loading={loading}>
            Confirm
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default EditDealContent;
